import { render, staticRenderFns } from "./EmailNotification.vue?vue&type=template&id=4b830f20&"
import script from "./EmailNotification.vue?vue&type=script&lang=js&"
export * from "./EmailNotification.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports